import { useEffect, useRef, useState } from "react";

/* Finger/pen/mouse signature pad. onChange(dataUrl|null) after each stroke. */
export const SignaturePad = ({ onChange, testid = "signature-pad", dark = false }) => {
  const ref = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = ref.current;
    const fit = () => {
      const r = c.getBoundingClientRect();
      const ratio = window.devicePixelRatio || 1;
      c.width = r.width * ratio;
      c.height = r.height * ratio;
      const ctx = c.getContext("2d");
      ctx.scale(ratio, ratio);
      ctx.lineWidth = 2.4;
      ctx.lineCap = "round";
      ctx.lineJoin = "round";
      ctx.strokeStyle = "#111";
      setEmpty(true);
      onChange(null);
    };
    fit();
    window.addEventListener("resize", fit);
    return () => window.removeEventListener("resize", fit);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange(null);
  };
  return (
    <div data-testid={testid}>
      <div className="relative">
        <canvas ref={ref} onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up}
          className="h-44 w-full touch-none rounded-sm bg-white" style={{ touchAction: "none" }} data-testid={`${testid}-canvas`} />
        {empty && <span className="pointer-events-none absolute inset-0 grid place-items-center text-sm text-zinc-500">Signer her med fingeren eller pennen</span>}
        <div className="pointer-events-none absolute bottom-8 left-6 right-6 border-b border-zinc-300" />
      </div>
      <button type="button" onClick={clear} data-testid={`${testid}-clear`}
        className={`mt-2 text-xs underline ${dark ? "text-zinc-300" : "text-zinc-600"}`}>Tøm og signer på nytt</button>
    </div>
  );
};
